<template>
  <publicImport :importTypeList="importTypeList"></publicImport>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import publicImport from "@/components/common/publicImport";

export default {
  name: "importTask",
  data() {
    return {
      importTypeList: [
        {value: 'attributeTemplateImport', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002098')},
        {value: 'ymsWarehouseLocationImport', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002620')},
        {value: 'LogisticsBillImport', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002936')},
        {value: 'categoryMappingImport', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002939')},
        {value: 'packageWeightImport', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002940')},
        {value: 'ymsProductImport', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002941')},
      ]
    };
  },
  components: {
    publicImport
  }
};
</script>

<style scoped>

</style>
